module.exports = __webpack_public_path__ + "static/media/nrm.b7f02324.JPG";